import { render, staticRenderFns } from "./TierIcon.vue?vue&type=template&id=48e43d1f&"
import script from "./TierIcon.vue?vue&type=script&lang=js&"
export * from "./TierIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports